function prepareTextForSearch(text: string): string {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
}

export function searchPosts(searchText: string, posts: Post[]): Post[] {
    const patternToSearch = prepareTextForSearch(searchText)
    return posts.filter((post) => {
        const fields = [post.data.title, post.data.snippet, post.data.description]
        return fields.filter(Boolean).some((f) => prepareTextForSearch(f).includes(patternToSearch))
    })
}
